module.exports = require('./helpers/bundle-url').getBundleURL('ekZ4q') + "calendar-icon.0245dede.png";